import pegasus from '../01-pegasus';
window.Pegasus = pegasus;

export default class AtrApp {
    activeMenuItem = false;
    subMenuOpen = false;
    atTop = true;
    nightMode = window.Pegasus.getCookie('nightMode');
    currency = window.Pegasus.getCookie('currency');
    openCurrencySelector = false;
    locationIndex = window.Pegasus.getCookie('locationIndex');

    init() {
        if (!this.locationIndex) {
            this.locationIndex = 'USD';
        }

        window.addEventListener('scroll', () => {
            this.atTop = window.scrollY < 200;
        });

        
        this.initTwoColumnBody();
        
        document.addEventListener("DOMContentLoaded", () => {
            this.replaceBrWithSpace();
            this.initExploreButton();
            this.initExploreLinks();
            this.initInquiryButtons();
            this.updatePricesByCurrency();
        });

        window.Pegasus.onResizeFinished(() => {
            this.replaceBrWithSpace();
        }, true);
    }

    toggleNightMode() {
        this.nightMode = this.nightMode === '1' ? '0' : '1';
        window.Pegasus.setCookie('nightMode', this.nightMode, 60);
    }

    updatePricesByCurrency() {
        const currency = window.Pegasus.getCookie('currency') || 'USD';
        document.querySelectorAll('.guidePrice').forEach(el => {
            if (el.dataset.prices === undefined) {
                return;
            }
            const prices = JSON.parse(el.dataset.prices);
            if (prices[currency] !== undefined) {
                let value = prices[currency];
                if (el.classList.contains('priceOnly')) {
                    value = value.replace(/^[^\d]+/, '').trim();
                }
                el.textContent = value;
            }
        });
    }

    updateCurrencyCodes() {
        const currency = window.Pegasus.getCookie('currency') || 'USD';
        document.querySelectorAll('.guidePriceCurrency').forEach(el => {
            el.textContent = currency;
        });
    }

    toggleCurrency(e) {
        this.currency = e.target.dataset.index;
        window.Pegasus.setCookie('currency', this.currency, 60);
        Alpine.store('location').set(this.currency);
        this.updatePricesByCurrency();
        this.updateCurrencyCodes();
    }

    toggleLocation(e) {
        this.locationIndex = e.target.dataset.index;
        window.Pegasus.setCookie('locationIndex', this.locationIndex, 60);
        Alpine.store('location').set(this.locationIndex);
    }

    initExploreButton() {
        // Select all a tags that include /explore/ somewhere in the href
        const links = document.querySelectorAll('a[href*="/explore/"], a[href*="/explore-"]');
        links.forEach(link => {
            link.addEventListener('click', () => {
                window.Pegasus.deleteCookie('lastExplorePage');
                window.Pegasus.setCookie('lastExplorePage', link.href, 1);

                // Ignore the click event if the current window href includes /explore-* or /explore/
                if (window.location.href.includes('/explore-') || window.location.href.includes('/explore/')) {
                    return;
                }

                window.Pegasus.deleteCookie('lastPage');
                window.Pegasus.setCookie('lastPage', window.location.href, 1);
            });
        });
    }

    initExploreLinks() {
        const allExploreLinks = document.querySelectorAll('a[href$="/explore/"]');
        allExploreLinks.forEach(link => {
            if (link.dataset.pegasusExplore === 'sentence') {
                if (window.Pegasus.getCookieWithoutDecoding('lastSentencePage')) {
                    link.href = window.Pegasus.getCookieWithoutDecoding('lastSentencePage');
                }
            } else if (window.Pegasus.getCookieWithoutDecoding('lastExplorePage')) {
                link.href = window.Pegasus.getCookieWithoutDecoding('lastExplorePage');
            }
        });
    }

    initInquiryButtons() {
        const links = document.querySelectorAll('a[href*="/contact/"]');

        links.forEach(link => {
            link.addEventListener('click', () => {
                window.Pegasus.deleteCookie('lastPage');
                window.Pegasus.setCookie('lastPage', window.location.href, 1);
            });
        });
    }

    initTwoColumnBody() {
        const columns = document.querySelectorAll('.wp-block-columns');

        columns.forEach(column => {
            const columnChildren = column.children;
            const columnCount = columnChildren.length;

            if (columnCount != 2) {
                return;
            }

            // Check if either of the 2 columns has a child that is a .wp-block-heading
            const hasHeading = Array.from(columnChildren).some(child => child.querySelector('.wp-block-heading'));

            if (!hasHeading) {
                return;
            }

            column.classList.add('two-column-body');
        });

        const twoColumnBodies = document.querySelectorAll('.two-column-body');

        twoColumnBodies.forEach(twoColumnBody => {

            const height = twoColumnBody.offsetHeight;

            if(height > 1000) {
                twoColumnBody.classList.add('in-view');
                return;
            }
            
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        twoColumnBody.classList.add('in-view');
                    }
                });
            }, {
                threshold: 0.15
            });

            observer.observe(twoColumnBody);

        });
    }

    replaceBrWithSpace() {
        if (window.innerWidth >= 768) {
            return;
        }
        document.querySelectorAll(".two-column-body .wp-block-heading.heading-two br").forEach(br => {
            br.replaceWith(" ");
        });
    }
}

window.addEventListener("pageshow", (event) => {
     if (!window.location.href.includes('/explore-') && !window.location.href.includes('/explore/') && !window.location.href.includes('/contact/')) {
        window.Pegasus.deleteCookie('lastPage');
        window.Pegasus.setCookie('lastPage', window.location.href, 1);
    }
});

document.addEventListener('alpine:init', () => {
    Alpine.store('location', {
        locationIndex: window.Pegasus.getCookie('locationIndex') || window.Pegasus.getCookie('currency') || 'USD',
        set(index) {
            this.locationIndex = index;
        }
    });
    Alpine.data('atrApp', () => new AtrApp());
});